import { avatarUrl, usePersonalAppearance, useSharedAppearance } from '../lib/appearance.js';
/** Existing 192 x 208 artwork cells, eight columns and nine animation rows (public/mascot/index.html names them). */
export type JabberMood = 'idle' | 'working' | 'review' | 'blocked' | 'wave' | 'jump';
const MOOD_CLASS: Record<JabberMood, string> = {
  idle: 'jabber-idle',
  working: 'jabber-working',
  review: 'jabber-review',
  blocked: 'jabber-blocked',
  wave: 'jabber-waving',
  jump: 'jabber-jump',
};
export function Jabber({ mood = 'idle', size = 'reply' }: { mood?: JabberMood; size?: 'icon' | 'reply' | 'welcome' | 'companion' }) {
  const personal = usePersonalAppearance(), shared = useSharedAppearance();
  const avatarId = shared ?? personal;
  // Only the classic otter is animated; the other artwork is a still image in the same frame.
  if (avatarId !== 'otter') {
    return (
      <span className={`jabber jabber-${size}`} role="img" aria-label="Jabberr · AI assistant">
        <img src={avatarUrl(avatarId)} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </span>
    );
  }
  return (
    <span className={`jabber jabber-${size}`} role="img" aria-label="Jabberr · AI assistant">
      <span className={`jabber-sprite ${MOOD_CLASS[mood]}`} />
    </span>
  );
}
